import type { FC } from 'react';
import { useUpdateField } from '../../../../../common/update-information/hooks/useUpdateField';
import {
  CommonNumericTextInputField,
  type CommonNumericTextInputProps,
} from '../../../../../common-ui/form-fields/CommonNumericTextInput';
import { getFieldProps } from '../../../../../common-ui/form-fields/getFieldProps';
import type { NumericFieldKeys } from '../../../../../services/update-form/updateFormReducer';

export interface NumericFieldProps
  extends Omit<CommonNumericTextInputProps, 'value' | 'onValueChange' | 'trackerAction'> {
  name: NumericFieldKeys;
}

export const NumericField: FC<NumericFieldProps> = ({ name, ...props }) => {
  const fieldProps = useUpdateField<NumericFieldKeys>(name);
  return (
    <CommonNumericTextInputField
      {...props}
      {...getFieldProps(props, fieldProps)}
      width={'100%'}
      changed={fieldProps.editedValue !== fieldProps.initialValue}
    />
  );
};
